<template>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title" v-if="type == 'mcl' && !company.ID">New Company</p>
            <p class="modal-card-title" v-else>ZoomInfo Enrichment</p>
        </header>
        <section class="modal-card-body">
            <div v-if="view == 'search'" style="height: 380px">
                <o-field label="Company Name">
                    <o-input v-model="name" placeholder="Company name"></o-input>
                </o-field>
                <o-field label="Web Address">
                    <o-input v-model="webaddress" placeholder="Web address"></o-input>
                </o-field>
                <o-field label="Country">
                    <autocomplete type="country" placeholder="Select a country" @input="SelectCountry"></autocomplete>
                </o-field>
            </div>
            <div v-if="view == 'review'">
                <loading v-if="loading"></loading>
                <div v-else>
                    <div class="mb-2" v-if="company.ExternalId3">
                        <o-checkbox v-model="metadata.cannotLink">Cannot be linked</o-checkbox>
                    </div>

                    <div>
                        <div class="is-size-5">Potential matches</div>
                    </div>

                    <div class="is-flex" style="gap:15px">
                        <div style="flex-grow:1">
                            <o-table style="min-width: 50%;" :data="items" :key="items.length" :mobile-cards="false" :row-class="SetRowActiveState">
                                <template #empty>
                                    <div class="has-text-centered">
                                        <b>Please modify your search</b>
                                    </div>
                                </template>
                                <o-table-column label="Company" v-slot="props">
                                    <a href="javascript://" @click="ClickRow(props.row, $event)">
                                        {{ props.row.name }}
                                    </a>
                                </o-table-column>
                                <o-table-column label="" v-slot="props">
                                    <o-button variant="primary" size="small" @click="OpenReview(props.row, $event)" v-if="view == 'review' && review">Preview</o-button>
                                    <o-button variant="primary" size="small" @click="Select(props.row, $event)" v-else>Select</o-button>
                                </o-table-column>

                            </o-table>
                        </div>

                        <div style="min-width: 400px; max-height:480px; position:sticky; top:0" v-if="activeStep >= 0">
                            <o-steps v-model="activeStep" animated :has-navigation="false" class="hide-step-nav">
                                <o-step-item v-for="(s, i) in items" :key="i" :value="i" :step="i">
                                    <card :title="s.name">
                                        <loading v-if="s.loading"></loading>
                                        <div v-else-if="s.company">
                                            <info-line label="Parent" :value="s.company?.ZI_C_IMMEDIATE_PARENT_NAME ? s.company?.ZI_C_IMMEDIATE_PARENT_NAME : 'This is the parent company'"></info-line>
                                            <info-line label="Employees" :value="s.company?.ZI_C_EMPLOYEES"></info-line>
                                            <div>
                                                <info-line label="Industries">
                                                    <div v-for="(industry, i) in ParseIndustries(s.company)" :key="i">
                                                        {{ industry }}
                                                    </div>
                                                </info-line>
                                                <br />
                                            </div>
                                            <info-line label="Ticker symbol" :value="s.company?.ZI_C_TICKER || s.company?.ZI_C_TICKERS_ALT || 'Not available'"></info-line>
                                            <info-line label="Revenue" :value="s.company?.ZI_C_COMPANY_REVENUE_RANGE"></info-line>

                                            <info-line label="Address" :loading="loading" v-if="s.company.ZI_C_STREET" :value="s.company.ZI_C_STREET"></info-line>
                                            <info-line label="City" :loading="loading" v-if="s.company.ZI_C_CITY" :value="s.company.ZI_C_CITY"></info-line>
                                            <info-line label="State" :loading="loading" v-if="s.company.ZI_C_STATE" :value="s.company.ZI_C_STATE"></info-line>
                                            <info-line label="Zip Code" :loading="loading" v-if="s.company.ZI_C_ZIP" :value="s.company.ZI_C_ZIP"></info-line>
                                            <info-line label="Country" :loading="loading" v-if="s.company.ZI_C_COUNTRY" :value="s.company.ZI_C_COUNTRY"></info-line>

                                            <info-line label="Web address" :href="s.company?.ZI_C_COMPANY_URL" :value="s.company?.ZI_C_COMPANY_URL"></info-line>
                                            <info-line label="Facebook" v-if="s.company?.ZI_C_FACEBOOK_URL">
                                                <a :href="FixLink(s.company?.ZI_C_FACEBOOK_URL)" target="_blank">Facebook <o-icon icon="external-link"></o-icon></a>
                                            </info-line>
                                            <info-line label="LinkedIn" v-if="s?.company.ZI_C_LINKEDIN_URL">
                                                <a :href="FixLink(s.company?.ZI_C_LINKEDIN_URL)" target="_blank">LinkedIn <o-icon icon="external-link"></o-icon></a>
                                            </info-line>
                                            <info-line label="Twitter" v-if="s.company?.ZI_C_TWITTER_URL">
                                                <a :href="FixLink(s.company?.ZI_C_TWITTER_URL)" target="_blank">Twitter <o-icon icon="external-link"></o-icon></a>
                                            </info-line>
                                        </div>
                                        <div v-else class="has-text-centered">
                                            <b>No Preview</b>
                                        </div>
                                    </card>
                                </o-step-item>
                            </o-steps>
                        </div>
                    </div>

                </div>
            </div>
        </section>
        <footer class="modal-card-foot is-justify-content-space-between">
            <div>
                <o-button variant="light" @click="Close" v-if="view == 'search'">Cancel</o-button>
                <o-button variant="light" @click="Back" icon-left="pencil" v-if="view == 'review'">Modify search</o-button>
            </div>
            <div>
                <o-button variant="light" @click="openManualEntry" v-if="view == 'review'"><span v-if="company.ID">Edit</span><span v-else>Enter</span> Manually</o-button>
                <o-button variant="primary" icon-left="search" :disabled="loading" @click="Search" v-if="view == 'search'">
                    Search
                </o-button>
            </div>
        </footer>
    </div>
</template>
<script>
    import enrichmentReviewModal from "@/components/modals/zoom-info/enrichment-preview.vue";
    import legacyEditCompanyModal from "@/components/modals/editCompany.vue";
    import { autocomplete } from "@/components/webComponents";
    import { ref, computed, watch, inject, onMounted, getCurrentInstance } from "vue";
    import infoLine from "@/components/webComponents/infoLine.vue";

    export default {
        components: {
            infoLine,
            autocomplete
        },
        props: {
            company: {
                type: Object,
                default: () => {
                    return {};
                }
            },
            autofill: {
                type: Boolean,
                default: false
            },
            type: {
                type: String,
                default: "mcl"
            },
            review: {
                type: Boolean,
                default: true
            }
        },
        emits: ["close"],
        setup(props, context) {
            const http = inject("$http");
            const oruga = inject("oruga");
            const isframe = inject("$isFrame");

            const view = ref('search');
            const loading = ref(false);
            const name = ref();
            const webaddress = ref();
            const country = ref();
            const items = ref([]);
            const activeStep = ref(-1);
            const metadata = ref({});

            if (props.type != "mcl") {
                try {
                    metadata.value = JSON.parse(props.company.ExternalId3);
                } catch (err) { console.log("no metadata"); }
            }

            const Close = () => {
                context.emit("close");
            };

            const Back = () => {
                view.value = 'search';
            };

            const ClickRow = (row, e) => {
                if (isframe) {
                    if (view.value == 'review') {
                        OpenReview(row, e);
                    }
                    else {
                        Select(row, e);
                    }
                }
                else {
                    if (view.value == 'review') {
                        OpenReview(row, e);
                    }
                    else {
                        Select(row, e);
                    }
                }
            }

            const SelectCountry = (result) => {
                country.value = result.text.trim();
            }

            const DoSearch = async () => {
                try {
                    const queryString = [{ key: "companyName", val: name.value }, { key: "companyWebAddress", val: webaddress.value }, { key: "companyCountry", val: country.value }];
                    const qs = "?" + queryString.filter(kv => kv.val).map(kv => kv.key + "=" + kv.val).join("&");
                    const resp = await http.get("/api/v2/company/zoominfo/search" + qs);
                    items.value = resp.data;
                }
                catch (err) {
                    console.error(err);
                }
            }

            const Search = async () => {
                if (view.value == 'search') {
                    loading.value = true;
                    view.value = 'review';
                    await DoSearch();
                }

                loading.value = false;
            }

            const openManualEntry = (item, e) => {
                e?.stopPropagation();

                Close();

                oruga.modal.open({
                    parent: getCurrentInstance(),
                    component: legacyEditCompanyModal,
                    width: 960,
                    trapFocus: true,
                    props: {
                        company: props.company
                    },
                    events: {
                        saved: (result) => {
                            result.close();
                        }
                    }
                });

            }

            const OpenReview = (item, e) => {
                e?.stopPropagation();

                oruga.modal.open({
                    parent: getCurrentInstance(),
                    component: enrichmentReviewModal,
                    width: 960,
                    trapFocus: true,
                    props: {
                        companyId: props.company.ID,
                        itemId: item.id,
                        type: props.type, // Determines what kind companyId is. If it's mcl then the mcl endpoint will be used, otherwise the Invenias endpoint will be used.
                        inveniasId: props.company?.InveniasID
                    },
                    events: {
                        onLinked: (result) => {
                            context.emit("close", { linked: true, zoominfoId: result.zoominfoId })
                        }
                    }
                });
            }

            const Select = (item, e) => {
                e.stopPropagation();
                context.emit("select", { item: item, close: (result) => { context.emit("close", result) } });
            }

            const GetEnrichment = async (item) => {
                if (!item.company) {
                    item.company = {}; //Prevent double calls
                    item.loading = true;

                    try {
                        const resp = await http.get("/api/v2/company/zoominfo/" + item.id + "/enrich");
                        item.company = resp.data;
                    }
                    catch (err) {
                        console.error(err);
                    }

                    item.loading = false;
                }
            }

            const SetActiveStep = (row, index) => {
                activeStep.value = index;
            }
            const SetRowActiveState = (row, index) => {
                if (activeStep.value == -1) return "";

                const activelyViewing = items.value[activeStep.value];
                if (activelyViewing && row.id == activelyViewing.id) {
                    GetEnrichment(activelyViewing);
                    return "is-active";
                }
                else return "";
            }

            const ParseIndustries = (company) => {
                if (company?.ZI_C_INDUSTRIES) {
                    try {
                        return JSON.parse(company.ZI_C_INDUSTRIES);
                    }
                    catch (err) {
                        return company.ZI_C_INDUSTRIES.split("|");
                    }
                }
                else return [];
            }

            const FixLink = (url) => {
                if (url) {
                    if (url.startsWith("http://") || url.startsWith("https://")) return url;
                    else {
                        url = "https://" + url;
                        return url;
                    }
                }
                else return "#";
            }

            const SaveMetadata = async () => {
                try {
                    await http.post(`/api/v2/company/invenias/${props.company?.InveniasID}/metadata`, {
                        metadata: metadata.value
                    });
                }
                catch (err) {
                    console.error(err);
                }
            }

            watch(() => metadata.value, (n, o) => {
                SaveMetadata();
            }, { deep: true })

            onMounted(() => {
                if (props.autofill) {
                    name.value = props.company.Name || props.company.CompanyName || "";
                }
            })

            return {
                view,
                loading,
                name,
                webaddress,
                country,
                items,
                activeStep,
                isframe,
                metadata,
                Close,
                Back,
                ClickRow,
                SelectCountry,
                Search,
                OpenReview,
                Select,
                SetActiveStep,
                SetRowActiveState,
                ParseIndustries,
                FixLink,
                SaveMetadata,
                openManualEntry
            };
        }
    };
</script>

<style lang="scss">
    @import "@/assets/css/globalVars.scss";

    table.table tr.is-active {
        background-color: $boyden-blue-lighter;
    }
</style>
